<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container *ngIf="records && records.length">
    <li class="nav-item dropdown-submenu submenu submenu-extra">

        <a class="sub-nav-link nav-link action-link dropdown-item dropdown-toggle pr-4"
           (touchstart)="onTouchStart($event)"
           (click)="toggleDropdown()">
            <scrm-image image="clock"></scrm-image>
            <scrm-label labelKey="LBL_LAST_VIEWED"></scrm-label>
        </a>

        <ul class="dropdown-menu submenu"
            [class.active]="showDropdown()"
        >
            <li *ngFor="let recentRecord of records | slice:0:maxDisplayed"
                class="nav-item"
                (click)="onItemClick($event)"
                (touchstart)="onItemTouchStart($event)"
            >
                <scrm-menu-item-link [class]="'submenu-nav-link nav-link action-link'"
                                     [link]="{
                                                label: recentRecord.attributes.item_summary,
                                                url: buildRoute(recentRecord),
                                                route: buildRoute(recentRecord)
                                             }">
                </scrm-menu-item-link>
            </li>
        </ul>
    </li>
</ng-container>



